import {
    TabComponent,
    TabItemDirective,
    TabItemsDirective,
} from '@syncfusion/ej2-react-navigations';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setRowData } from '../grid/gridReducer';
import {
    setSelectedRecrdsExport,
    setTabNameForRowData,
} from '../contactTabs/contactReducer';
import axios from 'axios';
import notify from '../../services/toasterService';
import AccessRequest from './accessrequest/accessrequest';
import RoleManagement from './roles/roles';
import UserManagement from './usermanagement/usermanagement';
import './AccessMgmt.scss';
import { getAccessMgmtEndPoint } from './utils';
import {
    setIsLoaderShow,
    setModulesList,
    setRolesData,
    setRolesList,
} from './accessmgmtReducer';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';

const parentTab = [
    { text: 'Users', id: '0' },
    { text: 'Roles', id: '1' },
    { text: 'Access Requests', id: '2' },
];

const AccessMgmt = () => {
    const dispatch = useDispatch();
    const [selectedTab, setSelectedTab] = useState<string>('USERS');

    useEffect(() => {
        dispatch(setRowData([]));
        dispatch(setSelectedRecrdsExport([]));
        dispatch(setTabNameForRowData(''));

        getRoles('Roles');
        getRolesAndModules('Roles');
        getRolesAndModules('All Modules');
    }, []);

    // const getTabEvent = (e: any) => {
    //     if (e !== null) {
    //         const selectedId = e.selectingID;
    //         parentTab.map((item) => {
    //             if (item.id === selectedId) {
    //                 selectedTab = item.text;
    //                 // userSignIn('signin');
    //                 // getAccessManagementTab(selectedTab);
    //             }
    //         });
    //     }
    // };

    const TabChangeEvent = async (e: any) => {
        dispatch(setRowData([]));
        dispatch(setSelectedRecrdsExport([]));
    };

    const getRolesAndModules = async (fieldName: any) => {
        const getEndPointUrl = getAccessMgmtEndPoint(fieldName);
        await axios
            .post(getEndPointUrl, {}, {})
            .then((res: { data: any }) => {
                if (fieldName === 'Roles') {
                    dispatch(setRolesList(res.data));
                } else if ((fieldName = 'All Modules')) {
                    dispatch(setModulesList(res.data));
                } else {
                }
            })
            .catch((err: any) => {
                console.log(err);
                notify(err, 'error');
            });
    };

    const getRoles = async (fieldName: any) => {
        dispatch(setIsLoaderShow(true));
        const getEndPointUrl = getAccessMgmtEndPoint(fieldName);
        await axios
            .post(getEndPointUrl, {})
            .then((res: { data: any }) => {
                dispatch(setIsLoaderShow(false));
                dispatch(setRolesData(res.data));
                dispatch(setRolesList(res.data));
            })
            .catch((err: any) => {
                dispatch(setIsLoaderShow(false));
                console.log(err);
                notify(
                    'Error! Unable to fetch data. Please try after sometime.',
                    'error'
                );
            });
    };

    const handleTabSelection = (event: any, tab: string) => {
        try {
            dispatch(setRowData([]));
            dispatch(setSelectedRecrdsExport([]));
            var btnSet;
            const elements = document.getElementsByClassName('activeTab');
            while (elements.length > 0)
                elements[0].classList.remove('activeTab');
            if (tab === 'USERS') {
                btnSet = document.getElementById('btnUser') as HTMLElement;
                btnSet.classList.add('activeTab');
            } else if (tab === 'ROLES') {
                btnSet = document.getElementById('btnRole') as HTMLElement;
                btnSet.classList.add('activeTab');
            } else if (tab === 'ACCESS_REQUESTS') {
                btnSet = document.getElementById(
                    'btnAccessRequest'
                ) as HTMLElement;
                btnSet.classList.add('activeTab');
            }

            setSelectedTab(tab);
        } catch (error) {}
    };

    return (
        <div className="col-sm-12 col-md-12 col-lg-12 parent-tab-width">
            <div className="contact-screen">
                <div className="tab-wrapper">
                    {/* <UserManagement /> */}
                    <ButtonComponent
                       
                        className="textTransform-initial  users activeTab"
                        id="btnUser"
                        onClick={(e) => handleTabSelection(e, 'USERS')}
                    >
                        Users
                    </ButtonComponent>

                    <ButtonComponent
                        
                        className="textTransform-initial  roles "
                        id="btnRole"
                        onClick={(e) => handleTabSelection(e, 'ROLES')}
                    >
                        Roles
                    </ButtonComponent>

                    <ButtonComponent
                       
                        className="textTransform-initial  access-request"
                        id="btnAccessRequest"
                        onClick={(e) =>
                            handleTabSelection(e, 'ACCESS_REQUESTS')
                        }
                    >
                        Access Requests
                    </ButtonComponent>
                </div>
                <div className="pt-1">
                    {selectedTab === 'USERS' && (
                        <div>
                            <UserManagement />
                        </div>
                    )}
                    {selectedTab === 'ROLES' && (
                        <div>
                            <RoleManagement />
                        </div>
                    )}

                    {selectedTab === 'ACCESS_REQUESTS' && (
                        <div>
                            <AccessRequest />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AccessMgmt;
